(function () {
  "use strict";

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
  function cssUrl(v) { return 'url("' + String(v || "").replace(/"/g, '\\"') + '")'; }
  function prefersMobile() { return window.matchMedia("(max-width: 760px)").matches; }
  function reducedMotion() { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
  function money(cents) {
    return (Number(cents || 0) / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL";
  }
  function isCustomItem(item) {
    var props = (item && item.properties) || {};
    return !!(props["Ürün"] || props["Ölçü"]);
  }
  /* 2026-09-11: "kendin tasarla" satirlarinda genel urun gorseli yerine musterinin yukledigi
     tasarim gorunsun. Ozellik SIRASINA gore ilk gorsel-benzeri deger secilir -- kirlentte form
     "1. Kirlent on yuz" once submit ettigi icin ozel bir siralamaya gerek yok. Hediye satirinin
     ozelligi ("Hediye tasarımı") bir tasarim ADI, URL degil -- desen zaten eslesmiyor. */
  function ilkOzelGorsel(props) {
    var anahtarlar = Object.keys(props || {});
    for (var i = 0; i < anahtarlar.length; i++) {
      if (anahtarlar[i].charAt(0) === "_") continue;
      var v = props[anahtarlar[i]];
      if (v && /^https?:\/\/.*\.(jpe?g|png)$/i.test(String(v))) return String(v);
    }
    return null;
  }
  function customUnitQty(item) {
    var props = (item && item.properties) || {};
    // Cart Transform modu: qty hack yok — satir adedi = parca adedi (birim 1).
    if (props["_rl_custom_price"]) return 1;
    return parseInt(props["_Birim teknik adet"], 10) || item.quantity || 1;
  }
  function customPieces(item) {
    if (!isCustomItem(item)) return item.quantity || 0;
    var unit = customUnitQty(item);
    return Math.max(1, Math.round((item.quantity || unit) / unit));
  }
  function logicalCartCount(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + (isCustomItem(item) ? customPieces(item) : (item.quantity || 0));
    }, 0);
  }

  /* ---------- GLOBAL: sepet (her sayfada) ---------- */
  /* GA4 (2026-09-04): sepet olaylari icin SON SEPET saklanir. Silinen satirin
     adini/fiyatini DOM'dan ayristirmak kirilgan olurdu (para bicimi "1.234,56 TL");
     sunucudan gelen veriyi kullanmak kesin sonuc verir. */
  var sonSepet = null;

  function gaSatir(it) {
    var adet = it.quantity || 1;
    var tutar = (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    return {
      item_id: it.handle || String(it.product_id || ""),
      item_name: it.product_title || it.title || "",
      item_variant: (it.properties && it.properties["Ölçü"]) || it.variant_title || "",
      price: Math.round((tutar / 100 / adet) * 100) / 100,
      quantity: adet
    };
  }

  function updateCartCount() {
    if (!window.fetch) return Promise.resolve(null);
    return window.fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (el) {
          el.textContent = logicalCartCount(cart);
        });
        sonSepet = cart;
        return cart;
      })
      .catch(function () { return null; });
  }

  function closeCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var scrim = document.querySelector(".rl-cartdrawer__scrim");
    document.documentElement.classList.remove("rl-cart-open");
    if (drawer) drawer.setAttribute("aria-hidden", "true");
    if (scrim) scrim.hidden = true;
  }

  function escHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  // Ucretsiz kargo ilerlemesi: esik 500 TL — mesaj + dolum cubugu, her AJAX cart guncellemesinde yenilenir.
  function renderShipProgress(cart) {
    var box = document.querySelector("[data-cart-ship]");
    if (!box || !cart) return;
    var threshold = parseInt(box.getAttribute("data-threshold"), 10) || 50000;
    var total = Number(cart.total_price || 0);
    var empty = !cart.items || !cart.items.length || cart.item_count === 0;
    box.hidden = empty;
    if (empty) return;
    var msg = box.querySelector("[data-cart-ship-msg]");
    var fill = box.querySelector("[data-cart-ship-fill]");
    var done = total >= threshold;
    box.classList.toggle("is-done", done);
    if (fill) fill.style.width = Math.min(100, (total / threshold) * 100).toFixed(1) + "%";
    if (msg) msg.textContent = done ? "Ücretsiz kargo kazandın ✓" : "Ücretsiz kargoya " + money(threshold - total) + " kaldı";
  }

  function renderCartDrawer(cart) {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer || !cart) return;
    var body = drawer.querySelector("[data-cart-drawer-items]");
    var total = drawer.querySelector("[data-cart-drawer-total]");
    if (total) total.textContent = money(cart.total_price);
    renderShipProgress(cart);
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="rl-cartdrawer__empty"><p>Sepetin boş.</p><a href="/collections/garage-lab">Garage Lab\'e göz at</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var props = item.properties || {};
      // Ozel olcu satiri: teknik urun yerine gercek urun adi + olcu goster, teknik adedi gizle.
      var isCustom = isCustomItem(item);
      var title = isCustom && props["Ürün"] ? props["Ürün"] : item.product_title;
      var meta = [];
      if (isCustom) {
        if (props["Ölçü"]) meta.push("Ölçü · " + props["Ölçü"]);
      } else if (item.variant_title && item.variant_title !== "Default Title") {
        meta.push(item.variant_title);
      }
      Object.keys(props).forEach(function (key) {
        if (key.charAt(0) === "_") return;
        if (isCustom && (key === "Ürün" || key === "Ölçü" || key === "Alan" || key === "Fiyat modeli" || key === "_Birim teknik adet")) return;
        var val = props[key];
        if (!val) return;
        if (/^https?:\/\//i.test(String(val))) val = "Yüklendi ✓"; // uzun tasarim linkini kisalt
        meta.push(key + ": " + val);
      });
      var key = escHtml(item.key);
      var ozelGorsel = ilkOzelGorsel(props);
      var image = ozelGorsel
        ? '<img src="' + escHtml(ozelGorsel) + '?width=240&height=240&crop=center" alt="Senin tasarımın" loading="lazy">'
        : (item.image ? '<img src="' + escHtml(item.image) + '&width=160" alt="" loading="lazy">' : '<span class="rl-cartdrawer__ph"></span>');
      var media = isCustom
        ? '<span class="rl-cartdrawer__media">' + image + '</span>'
        : '<a class="rl-cartdrawer__media" href="' + escHtml(item.url) + '">' + image + '</a>';
      var titleHtml = isCustom
        ? '<span class="rl-cartdrawer__title">' + escHtml(title) + '</span>'
        : '<a class="rl-cartdrawer__title" href="' + escHtml(item.url) + '">' + escHtml(title) + '</a>';
      var metaHtml = meta.map(function (m) { return '<span>' + escHtml(m) + '</span>'; }).join("");
      var unitQty = customUnitQty(item);
      var pieces = customPieces(item);
      var qtyHtml = isCustom ?
        '<div class="rl-cartdrawer__qty rl-cartdrawer__qty--custom">' +
          '<button type="button" data-cart-custom-qty data-key="' + key + '" data-unit="' + unitQty + '" data-pieces="' + Math.max(0, pieces - 1) + '" aria-label="Azalt">&minus;</button>' +
          '<span>' + pieces + '</span>' +
          '<button type="button" data-cart-custom-qty data-key="' + key + '" data-unit="' + unitQty + '" data-pieces="' + (pieces + 1) + '" aria-label="Arttır">+</button>' +
        '</div>' :
        '<div class="rl-cartdrawer__qty">' +
          '<button type="button" data-cart-qty data-key="' + key + '" data-q="' + (item.quantity - 1) + '" aria-label="Azalt">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-cart-qty data-key="' + key + '" data-q="' + (item.quantity + 1) + '" aria-label="Arttır">+</button>' +
        '</div>';
      // Cart Transform modu: AJAX sepeti transform edilmis fiyati yansitmayabilir — attribute'taki gercek fiyati goster.
      var lineTotal = item.final_line_price;
      if (isCustom && props["_rl_custom_price"] && /^\d+$/.test(String(props["_rl_custom_price"]))) {
        var ctUnit = parseInt(props["_rl_custom_price"], 10);
        if (lineTotal !== ctUnit * item.quantity) lineTotal = ctUnit * item.quantity;
      }
      return '<article class="rl-cartdrawer__item">' +
        media +
        '<div class="rl-cartdrawer__info">' +
          titleHtml +
          '<div class="rl-cartdrawer__meta">' + metaHtml + '</div>' +
          qtyHtml +
        '</div>' +
        '<div class="rl-cartdrawer__end">' +
          '<button type="button" class="rl-cartdrawer__x" data-cart-remove data-key="' + key + '" aria-label="Kaldır">&times;</button>' +
          '<strong class="rl-cartdrawer__price">' + money(lineTotal) + '</strong>' +
        '</div>' +
      '</article>';
    }).join("");
  }

  function removeCartItem(key, el) {
    if (!key || !window.fetch) return;
    /* GA4: satiri SILMEDEN ONCE onbellekten oku -- silindikten sonra veri yok. */
    var silinen = null;
    if (sonSepet && sonSepet.items) {
      for (var i = 0; i < sonSepet.items.length; i++) {
        if (String(sonSepet.items[i].key) === String(key)) { silinen = sonSepet.items[i]; break; }
      }
    }
    if (el) { el.disabled = true; el.textContent = "..."; }
    window.fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { if (!r.ok) throw new Error("remove failed"); return r.json(); })
      .then(function (cart) {
        Array.prototype.slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (c) { c.textContent = logicalCartCount(cart); });
        sonSepet = cart;
        if (silinen && window.rlGA) {
          var sat = gaSatir(silinen);
          window.rlGA("remove_from_cart", {
            currency: cart.currency || "TRY",
            value: Math.round(sat.price * sat.quantity * 100) / 100,
            items: [sat]
          });
        }
        renderCartDrawer(cart);
      })
      .catch(function () { if (el) { el.disabled = false; el.textContent = "Kaldır"; } });
  }

  function changeCartQty(key, q, el) {
    if (!key || !window.fetch) return;
    if (q < 0) q = 0;
    if (el) el.disabled = true;
    window.fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: q })
    })
      .then(function (r) { if (!r.ok) throw new Error("qty failed"); return r.json(); })
      .then(function (cart) {
        Array.prototype.slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (c) { c.textContent = logicalCartCount(cart); });
        renderCartDrawer(cart);
      })
      .catch(function () { if (el) el.disabled = false; });
  }

  function changeCustomPieces(key, pieces, unitQty, el) {
    if (!key || !window.fetch) return;
    pieces = Math.max(0, parseInt(pieces, 10) || 0);
    unitQty = Math.max(1, parseInt(unitQty, 10) || 1);
    if (el) el.disabled = true;
    window.fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: pieces * unitQty })
    })
      .then(function (r) { if (!r.ok) throw new Error("custom qty failed"); return r.json(); })
      .then(function (cart) {
        Array.prototype.slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (c) { c.textContent = logicalCartCount(cart); });
        renderCartDrawer(cart);
      })
      .catch(function () { if (el) el.disabled = false; });
  }

  function openCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var scrim = document.querySelector(".rl-cartdrawer__scrim");
    if (!drawer) return updateCartCount();
    if (scrim) scrim.hidden = false;
    document.documentElement.classList.add("rl-cart-open");
    drawer.setAttribute("aria-hidden", "false");
    return updateCartCount().then(function (cart) {
      /* GA4: view_cart -- kanal pixel'i bunu GONDERMIYOR, guvenli. */
      if (cart && window.rlGA) {
        window.rlGA("view_cart", {
          currency: cart.currency || "TRY",
          value: (cart.total_price || 0) / 100,
          items: (cart.items || []).map(gaSatir)
        });
      }
      return cart;
    }).then(renderCartDrawer);
  }

  function addToCart(variantId, btn) {
    if (!variantId || !window.fetch) return;
    var label = btn.textContent;
    btn.classList.add("is-busy");
    btn.disabled = true;
    window.fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () {
        btn.classList.remove("is-busy");
        btn.classList.add("is-done");
        btn.textContent = "Eklendi";
        openCartDrawer();
        window.setTimeout(function () { btn.classList.remove("is-done"); btn.textContent = label; btn.disabled = false; }, 1700);
      })
      .catch(function () {
        btn.classList.remove("is-busy");
        btn.textContent = "Tekrar dene";
        window.setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1700);
      });
  }

  window.RugLabCart = {
    update: updateCartCount,
    open: openCartDrawer,
    close: closeCartDrawer
  };

  function fixPillowPageText() {
    if (window.location.pathname.indexOf("/products/kendi-kirlentini-tasarla") === -1) return;
    var title = document.querySelector(".rl-pdp__title");
    var desc = document.querySelector(".rl-pdp__desc");
    var select = document.querySelector("[data-ruglab-design] select");
    if (title) title.textContent = "Kendi K\u0131rlentini Tasarla";
    if (desc) desc.textContent = "\u00d6n y\u00fcz tasar\u0131m\u0131n\u0131 y\u00fckle; istersen arka y\u00fcz i\u00e7in ikinci g\u00f6rsel ekle. Tekli, 2'li veya 4'l\u00fc paket se\u00e7ene\u011fiyle sipari\u015f ver.";
    if (!select || !select.options) return;
    [
      "Tekli 45x45 cm",
      "2'li Set 45x45 cm",
      "4'l\u00fc Set 45x45 cm"
    ].forEach(function (label, index) {
      var option = select.options[index];
      if (!option) return;
      var price = (option.textContent.match(/\s+\u2014\s+.+$/) || [""])[0];
      option.textContent = label + price;
    });
  }

  function bindGlobal() {
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var add = e.target.closest("[data-add]");
      if (add) { e.preventDefault(); addToCart(add.getAttribute("data-variant"), add); return; }
      var cartOpen = e.target.closest("[data-cart-open]");
      if (cartOpen) {
        e.preventDefault();
        openCartDrawer();
        var menu = document.querySelector("[data-menu]"); var menuScrim = document.querySelector(".rl-menu__scrim");
        if (menu) { menu.classList.remove("is-open"); menu.setAttribute("aria-hidden", "true"); document.documentElement.classList.remove("rl-menu-open"); if (menuScrim) menuScrim.hidden = true; }
        return;
      }
      if (e.target.closest("[data-cart-close]")) { closeCartDrawer(); return; }
      var rm = e.target.closest("[data-cart-remove]");
      if (rm) { e.preventDefault(); removeCartItem(rm.getAttribute("data-key"), rm); return; }
      var qb = e.target.closest("[data-cart-qty]");
      if (qb) { e.preventDefault(); changeCartQty(qb.getAttribute("data-key"), parseInt(qb.getAttribute("data-q"), 10), qb); return; }
      var cqb = e.target.closest("[data-cart-custom-qty]");
      if (cqb) { e.preventDefault(); changeCustomPieces(cqb.getAttribute("data-key"), cqb.getAttribute("data-pieces"), cqb.getAttribute("data-unit"), cqb); return; }
      var mt = e.target.closest("[data-menu-toggle]");
      if (mt) {
        var m = document.querySelector("[data-menu]"); var sc = document.querySelector(".rl-menu__scrim");
        if (m) { var open = m.classList.toggle("is-open"); document.documentElement.classList.toggle("rl-menu-open", open); m.setAttribute("aria-hidden", open ? "false" : "true"); mt.setAttribute("aria-expanded", open ? "true" : "false"); if (sc) sc.hidden = !open; }
        return;
      }
      if (e.target.closest("[data-menu-close]")) {
        var m2 = document.querySelector("[data-menu]"); var sc2 = document.querySelector(".rl-menu__scrim");
        if (m2) { m2.classList.remove("is-open"); m2.setAttribute("aria-hidden", "true"); document.documentElement.classList.remove("rl-menu-open"); if (sc2) sc2.hidden = true; }
        return;
      }
      var promo = e.target.closest("[data-rl-promo]");
      if (promo) {
        var lead = document.querySelector("[data-rl-lead]");
        if (lead) {
          e.preventDefault();
          lead.hidden = !lead.hidden;
          if (!lead.hidden) { var inp = lead.querySelector("input[type=email]"); if (inp) inp.focus(); }
        }
        return;
      }
      if (e.target.closest("[data-lead-close]")) {
        var lc = e.target.closest("[data-rl-lead]"); if (lc) lc.hidden = true; return;
      }
      var codeBtn = e.target.closest("[data-lead-code]");
      if (codeBtn && navigator.clipboard) {
        var orig = codeBtn.getAttribute("data-code") || codeBtn.textContent.trim();
        codeBtn.setAttribute("data-code", orig);
        navigator.clipboard.writeText(orig).then(function () {
          codeBtn.textContent = "Kopyalandi ✓";
          window.setTimeout(function () { codeBtn.textContent = orig; }, 1500);
        }).catch(function () {});
      }
    });

    // 2026-09-21: AJAX gonderim KALDIRILDI. Shopify'in robot korumasi (hCaptcha, sayfaya
    // gomulu betik) bu formun submit'ini kendisi yakalayip dogrulama anahtariyla dogal POST
    // yapiyor; bizim fetch'imiz anahtarsiz gidip 400 "Missing CAPTCHA token" aliyordu ve
    // onunla yarisiyordu (bazen kayit olusuyor, bazen olusmuyordu). Artik yalniz dugmeyi
    // "..." yapiyoruz; sayfa ?customer_posted=true ile doner, rl-header basari panelini acar.
    document.addEventListener("submit", function (e) {
      var lead = e.target.closest ? e.target.closest("[data-rl-lead]") : null;
      if (!lead) return;
      var btn = e.target.querySelector("button[type=submit]");
      if (btn) btn.textContent = "...";
    });

    window.addEventListener("pageshow", updateCartCount);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCartDrawer();
    });
    updateCartCount();
  }

  /* ---------- HOMEPAGE STUDIO ---------- */
  function readData(root) {
    var node = root.querySelector("[data-ruglab-data]");
    if (!node) return [];
    try { return JSON.parse(node.textContent || "[]"); } catch (e) { return []; }
  }

  function initStudio(root) {
    if (root.getAttribute("data-ruglab-ready") === "v10") return;
    root.setAttribute("data-ruglab-ready", "v10");

    var labs = readData(root);
    var sceneEl = root.querySelector("[data-scene]");
    var roomEl = root.querySelector("[data-room]");
    var roomPrev = root.querySelector("[data-room-prev]");
    var roomCurrent = root.querySelector("[data-room-current]");
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-lab-card]"));

    var drawerLabel = root.querySelector("[data-drawer-label]");
    var drawerTitle = root.querySelector("[data-drawer-title]");
    var drawerText = root.querySelector("[data-drawer-text]");
    var drawerLink = root.querySelector("[data-drawer-link]");
    var closeLab = root.querySelector("[data-close-lab]");
    var navPrevTitle = root.querySelector("[data-nav-prev-title]");
    var navNextTitle = root.querySelector("[data-nav-next-title]");
    var prevButtons = Array.prototype.slice.call(root.querySelectorAll("[data-lab-prev]"));
    var nextButtons = Array.prototype.slice.call(root.querySelectorAll("[data-lab-next]"));

    // Rota ve etiketler DOM sirasinda sabittir: Garage -> Arcade -> Wild -> Art -> Street -> Mood.
    (function relabelRoute() {
      labs.forEach(function (_, li) {
        var r = li;
        var lbl = "LAB " + ("0" + (r + 1)).slice(-2);
        if (labs[li]) labs[li].label = lbl;
        var el = cards[li] && cards[li].querySelector(".rl-lab__label");
        if (el) el.textContent = lbl;
      });
    })();

    var activeIndex = -1;
    var animTimer = 0;
    var idleTimer = 0;
    var swipeX = 0, swipeY = 0, swiping = false;
    var preloadedScenes = {};
    var prefetchedPages = {};
    var transitionRequest = 0;
    var leavingForCollection = false;
    var navLocked = false;
    var pendingNavStep = 0;

    function defaultUrl() { return (drawerLink && drawerLink.getAttribute("href")) || "/collections/tum-urunler"; }
    function collectionUrl(d) { return (d && d.url) || defaultUrl(); }
    function sceneUrl(d, deep) {
      d = d || {};
      if (deep) return prefersMobile() ? (d.deepMobile || d.deepDesktop) : (d.deepDesktop || d.deepMobile);
      return prefersMobile() ? (d.mobileImage || d.desktopImage) : (d.desktopImage || d.mobileImage);
    }
    function preloadScene(url, priority) {
      if (!url) return Promise.resolve("");
      if (preloadedScenes[url]) {
        if (priority === "high" && preloadedScenes[url].image) {
          preloadedScenes[url].image.fetchPriority = "high";
        }
        return preloadedScenes[url].promise;
      }
      var image = new Image();
      image.decoding = "async";
      if (priority) image.fetchPriority = priority;
      var settled = false;
      var promise = new Promise(function (resolve) {
        function finish() {
          if (settled) return;
          settled = true;
          if (image.decode) {
            image.decode().catch(function () {}).then(function () { resolve(url); });
          } else {
            resolve(url);
          }
        }
        image.onload = finish;
        image.onerror = finish;
        image.src = url;
        if (image.complete) finish();
      });
      preloadedScenes[url] = { image: image, promise: promise };
      return promise;
    }
    function prefetchPage(url) {
      if (!url) return Promise.resolve("");
      var absolute;
      try { absolute = new URL(url, window.location.origin); } catch (ignore) { return Promise.resolve(""); }
      if (absolute.origin !== window.location.origin) return Promise.resolve("");
      if (prefetchedPages[absolute.href]) return prefetchedPages[absolute.href];
      var promise = Promise.resolve(absolute.href);
      if (window.fetch) {
        promise = window.fetch(absolute.href, {
          credentials: "same-origin",
          cache: "default"
        }).then(function () { return absolute.href; }).catch(function () { return absolute.href; });
      } else {
        var link = document.createElement("link");
        link.rel = "prefetch";
        link.as = "document";
        link.href = absolute.href;
        document.head.appendChild(link);
      }
      prefetchedPages[absolute.href] = promise;
      return promise;
    }
    function warmFocusScene(d, priority) {
      if (!d) return Promise.resolve("");
      return preloadScene(sceneUrl(d, false), priority || "high");
    }
    function warmDeepSceneAndPage(d) {
      if (!d) return;
      preloadScene(sceneUrl(d, true), "low").then(function () {
        prefetchPage(collectionUrl(d));
      });
    }
    function warmNeighborFocus(index) {
      if (!labs.length || index < 0) return;
      var order = navOrderIdx();
      var pos = order.indexOf(index);
      if (pos < 0) return;
      [-1, 1].forEach(function (step) {
        var neighbor = labs[order[(pos + step + order.length) % order.length]];
        preloadScene(sceneUrl(neighbor, false), "high");
      });
    }
    function setRoomLayer(layer, url) {
      if (!layer) return;
      layer.style.backgroundImage = url ? "url(" + JSON.stringify(url) + ")" : "";
      layer.setAttribute("data-scene-url", url || "");
    }
    function currentRoomUrl() {
      return roomCurrent ? roomCurrent.getAttribute("data-scene-url") || "" : "";
    }

    var CAMERA_PRESETS = {
      garage: { desktop: { x: 18, y: 62, zoom: 2.55 }, mobile: { x: 25, y: 62, zoom: 2.35 } },
      arcade: { desktop: { x: 34, y: 25, zoom: 2.35 }, mobile: { x: 28, y: 22, zoom: 2.35 } },
      wild: { desktop: { x: 51, y: 23, zoom: 2.3 }, mobile: { x: 51, y: 16, zoom: 2.45 } },
      art: { desktop: { x: 66, y: 27, zoom: 2.35 }, mobile: { x: 72, y: 24, zoom: 2.35 } },
      street: { desktop: { x: 85, y: 40, zoom: 2.55 }, mobile: { x: 84, y: 43, zoom: 2.45 } },
      mood: { desktop: { x: 82, y: 76, zoom: 2.55 }, mobile: { x: 78, y: 72, zoom: 2.25 } }
    };

    function focusMetrics(d) {
      d = d || {};
      var mobile = prefersMobile();
      var mode = mobile ? "mobile" : "desktop";
      var preset = CAMERA_PRESETS[d.style] && CAMERA_PRESETS[d.style][mode];
      var x = preset ? preset.x : (Number(mobile ? d.mobileFocusX : d.focusX) || 50);
      var y = preset ? preset.y : (Number(mobile ? d.mobileFocusY : d.focusY) || 50);
      var w = Math.max(8, Number(mobile ? d.mobileFocusW : d.focusW) || 24);
      var h = Math.max(8, Number(mobile ? d.mobileFocusH : d.focusH) || 40);
      var zoom = preset ? preset.zoom : clamp(Math.min(92 / w, 92 / h), 1.45, mobile ? 4.2 : 3.8);
      var minCenter = 50 / zoom;
      x = clamp(x, minCenter, 100 - minCenter);
      y = clamp(y, minCenter, 100 - minCenter);
      return {
        zoom: zoom,
        tx: (50 - x) * zoom,
        ty: (50 - y) * zoom
      };
    }

    function roomTransform(metrics) {
      return "translate3d(" + metrics.tx.toFixed(3) + "vw," + metrics.ty.toFixed(3) + "vh,0) scale(" + metrics.zoom.toFixed(4) + ")";
    }

    function applyRoomFocus(layer, d) {
      if (!layer) return;
      var metrics = focusMetrics(d);
      layer.style.setProperty("--room-tx", metrics.tx.toFixed(3) + "vw");
      layer.style.setProperty("--room-ty", metrics.ty.toFixed(3) + "vh");
      layer.style.setProperty("--room-zoom", metrics.zoom.toFixed(4));
      layer.style.transform = roomTransform(metrics);
    }

    function setZoomOrigin(x, y) {
      var rect = sceneEl ? sceneEl.getBoundingClientRect() : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
      root.style.setProperty("--zoom-x", clamp(((x - rect.left) / rect.width) * 100, 6, 94).toFixed(1) + "%");
      root.style.setProperty("--zoom-y", clamp(((y - rect.top) / rect.height) * 100, 6, 94).toFixed(1) + "%");
    }
    function setPan(x, y) {
      var rect = sceneEl ? sceneEl.getBoundingClientRect() : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
      var px = ((rect.left + rect.width / 2 - x) / rect.width) * 5;
      var py = ((rect.top + rect.height / 2 - y) / rect.height) * 4;
      root.style.setProperty("--pan-x", clamp(px, -3, 3).toFixed(2) + "vw");
      root.style.setProperty("--pan-y", clamp(py, -2.4, 2.4).toFixed(2) + "vh");
    }
    function setAccent(i) { root.style.setProperty("--active-accent", (labs[i] && labs[i].accent) || "#d8b56d"); }

    var STYLES = ["garage", "arcade", "wild", "art", "mood", "street", "classic"];
    function setStyle(i) {
      for (var s = 0; s < STYLES.length; s++) root.classList.remove("rl-style-" + STYLES[s]);
      root.classList.add("rl-style-" + (((labs[i] && labs[i].style) || "classic")));
    }
    function clearStyle() { for (var s = 0; s < STYLES.length; s++) root.classList.remove("rl-style-" + STYLES[s]); }

    function setDrawer(i) {
      var d = labs[i] || {};
      if (drawerLabel) drawerLabel.textContent = d.label || "";
      if (drawerTitle) drawerTitle.textContent = d.title || "";
      if (drawerText) drawerText.textContent = d.text || "";
      if (drawerLink) {
        if (d.comingSoon) {
          drawerLink.href = "https://www.instagram.com/ruglabtr/";
          drawerLink.target = "_blank";
          drawerLink.rel = "noopener";
          drawerLink.classList.add("is-soon");
          drawerLink.innerHTML = "Yakında &mdash; Instagram'da takip et <span aria-hidden=\"true\">&rarr;</span>";
        } else {
          drawerLink.href = collectionUrl(d);
          drawerLink.removeAttribute("target");
          drawerLink.removeAttribute("rel");
          drawerLink.classList.remove("is-soon");
          drawerLink.innerHTML = "Koleksiyona git <span aria-hidden=\"true\">&rarr;</span>";
        }
      }
    }
    function setNavTitles(i) {
      if (!labs.length) return;
      var order = navOrderIdx();
      var pos = order.indexOf(i);
      if (pos < 0) pos = 0;
      var p = labs[order[(pos - 1 + order.length) % order.length]] || {};
      var n = labs[order[(pos + 1) % order.length]] || {};
      if (navPrevTitle) navPrevTitle.textContent = p.title || "Önceki";
      if (navNextTitle) navNextTitle.textContent = n.title || "Sonraki";
    }

    function setStudioViewportLock(locked) {
      document.documentElement.classList.toggle("rl-studio-locked", locked);
      document.body.classList.toggle("rl-studio-locked", locked);
    }

    function restart(cls, duration, done) {
      root.classList.remove("is-entering", "is-sliding-next", "is-sliding-prev", "is-diving");
      root.classList.add(cls);
      window.clearTimeout(animTimer);
      animTimer = window.setTimeout(function () {
        root.classList.remove("is-entering", "is-sliding-next", "is-sliding-prev", "is-diving");
        setRoomLayer(roomPrev, "");
        if (done) done();
      }, duration);
    }

    function focusLab(index, origin) {
      if (!cards.length) return;
      var i = (index + cards.length) % cards.length;
      var d = labs[i] || {};
      var focusUrl = sceneUrl(d, false);
      var request = ++transitionRequest;
      var cameraOrigin = origin;
      if (!cameraOrigin && cards[i]) {
        var cardRect = cards[i].getBoundingClientRect();
        cameraOrigin = { x: cardRect.left + cardRect.width / 2, y: cardRect.top + cardRect.height / 2 };
      }
      cameraOrigin = cameraOrigin || { x: window.innerWidth / 2, y: window.innerHeight / 2 };
      setZoomOrigin(cameraOrigin.x, cameraOrigin.y);
      setPan(cameraOrigin.x, cameraOrigin.y);
      preloadScene(focusUrl, "high").then(function () {
        if (request !== transitionRequest) return;
        setRoomLayer(roomPrev, "");
        setRoomLayer(roomCurrent, focusUrl);
        setAccent(i); setStyle(i);
        setDrawer(i); setNavTitles(i);
        cards.forEach(function (c, ci) { c.classList.toggle("is-active", ci === i); });
        activeIndex = i;
        stopIdle();
        setStudioViewportLock(true);
        root.classList.add("is-focused");
        restart("is-entering", 250);
        warmDeepSceneAndPage(d);
        warmNeighborFocus(i);
      });
    }

    /* Gezinme sirasi sabit DOM rotasidir; gorseldeki X konumu sirayi degistirmez. */
    function navOrderIdx() {
      return labs.map(function (_, i) { return i; });
    }
    function moveLab(step) {
      if (activeIndex < 0) return;
      if (navLocked) {
        pendingNavStep = step;
        return;
      }
      navLocked = true;
      var order = navOrderIdx();
      var pos = order.indexOf(activeIndex);
      if (pos < 0) pos = 0;
      var i = order[(pos + step + order.length) % order.length];
      if (i === activeIndex) {
        navLocked = false;
        return;
      }
      var d = labs[i] || {};
      var nextUrl = sceneUrl(d, false);
      var request = ++transitionRequest;
      preloadScene(nextUrl, "high").then(function () {
        if (request !== transitionRequest) {
          navLocked = false;
          return;
        }
        setRoomLayer(roomPrev, currentRoomUrl());
        setRoomLayer(roomCurrent, nextUrl);
        activeIndex = i;
        setAccent(i); setStyle(i); setDrawer(i); setNavTitles(i);
        cards.forEach(function (c, ci) { c.classList.toggle("is-active", ci === i); });
        restart(step > 0 ? "is-sliding-next" : "is-sliding-prev", 230, function () {
          navLocked = false;
          if (pendingNavStep) {
            var queuedStep = pendingNavStep;
            pendingNavStep = 0;
            moveLab(queuedStep);
          }
        });
        warmDeepSceneAndPage(d);
        warmNeighborFocus(i);
      });
    }

    function clearFocus() {
      ++transitionRequest;
      activeIndex = -1;
      root.classList.remove("is-focused", "is-entering", "is-sliding-next", "is-sliding-prev", "is-diving");
      root.style.setProperty("--zoom-x", "50%");
      root.style.setProperty("--zoom-y", "50%");
      root.style.setProperty("--pan-x", "0px");
      root.style.setProperty("--pan-y", "0px");
      clearStyle();
      setRoomLayer(roomPrev, "");
      setRoomLayer(roomCurrent, "");
      if (drawerLink) drawerLink.removeAttribute("aria-busy");
      leavingForCollection = false;
      navLocked = false;
      pendingNavStep = 0;
      setStudioViewportLock(false);
      cards.forEach(function (c) { c.classList.remove("is-active"); });
      armIdle();
    }

    /* idle -> tiklamaya tesvik */
    function stopIdle() { window.clearTimeout(idleTimer); root.classList.remove("rl-idle"); }
    function armIdle() {
      window.clearTimeout(idleTimer);
      root.classList.remove("rl-idle");
      if (activeIndex >= 0) return;
      idleTimer = window.setTimeout(function () { if (activeIndex < 0) root.classList.add("rl-idle"); }, 1800);
    }

    cards.forEach(function (card, index) {
      function warm() { warmFocusScene(labs[index] || {}, "high"); }
      card.addEventListener("pointerenter", warm, { passive: true });
      card.addEventListener("touchstart", warm, { passive: true, once: true });
      card.addEventListener("click", function (event) {
        // Zaten odakli oldugumuz lab'e tekrar tiklaninca giris animasyonunu YENIDEN oynatma (Doruk bug raporu).
        if (index === activeIndex && root.classList.contains("is-focused")) return;
        focusLab(index, { x: event.clientX || window.innerWidth / 2, y: event.clientY || window.innerHeight / 2 });
      });
    });
    prevButtons.forEach(function (b) {
      b.addEventListener("dblclick", function (event) { event.preventDefault(); });
      b.addEventListener("click", function () { moveLab(-1); });
    });
    nextButtons.forEach(function (b) {
      b.addEventListener("dblclick", function (event) { event.preventDefault(); });
      b.addEventListener("click", function () { moveLab(1); });
    });
    if (closeLab) closeLab.addEventListener("click", clearFocus);
    if (drawerLink) drawerLink.addEventListener("click", function (event) {
      if (activeIndex < 0 || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var d = labs[activeIndex] || {};
      if (d.comingSoon || drawerLink.target === "_blank") return;
      var deepUrl = sceneUrl(d, true);
      var targetUrl = collectionUrl(d);
      try {
        window.sessionStorage.setItem("rlSceneTransition", JSON.stringify({ key: d.key || d.style || "", at: Date.now(), from: "studio" }));
      } catch (ignore) {}
      if (!deepUrl || !roomCurrent || !roomPrev) return;
      event.preventDefault();
      drawerLink.setAttribute("aria-busy", "true");
      prefetchPage(targetUrl);
      var diveStarted = false;
      function startDive() {
        if (diveStarted) return;
        diveStarted = true;
        leavingForCollection = true;
        setRoomLayer(roomPrev, currentRoomUrl());
        setRoomLayer(roomCurrent, deepUrl);
        root.classList.remove("is-entering", "is-sliding-next", "is-sliding-prev", "is-diving");
        void root.offsetWidth;
        root.classList.add("is-diving");
        window.setTimeout(function () { window.location.assign(targetUrl); }, reducedMotion() ? 0 : 310);
      }
      // 2026-09-11: sahne gorseli ne yuklenip ne hata verirse (takilan mobil baglanti) promise
      // hic cozulmuyordu -> link preventDefault edildigi icin kullanici ana sayfada kaliyordu.
      // En fazla 1200 ms bekle, sonra her durumda gec.
      Promise.race([
        preloadScene(deepUrl, "high"),
        new Promise(function (resolve) { window.setTimeout(resolve, 1200); })
      ]).then(startDive);
    });

    function warmFocusScenes() {
      var queue = labs.slice();
      function warmNext() {
        var d = queue.shift();
        if (!d) return;
        warmFocusScene(d, "low").then(function () {
          if ("requestIdleCallback" in window) {
            window.requestIdleCallback(warmNext, { timeout: 900 });
          } else {
            window.setTimeout(warmNext, 240);
          }
        });
      }
      warmNext();
    }
    // 2026-08-11 olcum: mobilde 6 lab focus sahnesini pesin indirmek ~1.542 KB bosa trafik
    // (sayfanin 2,7 MB toplaminin %57'si) ve kullanici cogu ziyarette hicbir lab'e girmiyor.
    // Bir lab'e dokunulunca zaten preloadScene(focusUrl, "high") calisiyor, o yol bozulmadi.
    var rlConn = navigator.connection || {};
    var rlStingy = prefersMobile() || rlConn.saveData === true || /(^|-)2g$/.test(rlConn.effectiveType || "");
    if (!rlStingy) {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(warmFocusScenes, { timeout: 700 });
      } else {
        window.setTimeout(warmFocusScenes, 180);
      }
    }

    root.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-focused")) { clearFocus(); return; }
      if (!root.classList.contains("is-focused")) return;
      if (e.key === "ArrowLeft") moveLab(-1);
      if (e.key === "ArrowRight") moveLab(1);
    });

    root.addEventListener("pointerdown", function (e) {
      if (!root.classList.contains("is-focused")) return;
      if (e.target.closest && e.target.closest(".rl-drawer__cta, .rl-drawer__close, .rl-nav")) return;
      swipeX = e.clientX; swipeY = e.clientY; swiping = true;
    });
    root.addEventListener("pointerup", function (e) {
      if (!swiping || !root.classList.contains("is-focused")) return;
      swiping = false;
      var dx = e.clientX - swipeX, dy = e.clientY - swipeY;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      moveLab(dx < 0 ? 1 : -1);
    });

    ["pointermove", "pointerdown", "keydown", "wheel", "touchstart"].forEach(function (ev) {
      root.addEventListener(ev, function () { if (activeIndex < 0) armIdle(); }, { passive: true });
    });
    var cameraResizeTimer = 0;
    window.addEventListener("resize", function () {
      window.clearTimeout(cameraResizeTimer);
      cameraResizeTimer = window.setTimeout(function () {
        if (activeIndex >= 0) {
          var d = labs[activeIndex] || {};
          setRoomLayer(roomCurrent, sceneUrl(d, false));
          preloadScene(sceneUrl(d, true));
        }
      }, 120);
    });
    function restoreFocusedRoom() {
      if (activeIndex < 0) return;
      var d = labs[activeIndex] || {};
      var focusUrl = sceneUrl(d, false);
      ++transitionRequest;
      window.clearTimeout(animTimer);
      root.classList.remove("is-entering", "is-sliding-next", "is-sliding-prev", "is-diving");
      setRoomLayer(roomPrev, "");
      setRoomLayer(roomCurrent, focusUrl);
      if (drawerLink) drawerLink.removeAttribute("aria-busy");
      leavingForCollection = false;
      navLocked = false;
      pendingNavStep = 0;
      setStudioViewportLock(true);
      preloadScene(focusUrl, "high");
    }
    window.addEventListener("pagehide", function () {
      if (leavingForCollection) restoreFocusedRoom();
    });
    window.addEventListener("pageshow", function () {
      if (activeIndex < 0) return;
      var focusUrl = sceneUrl(labs[activeIndex] || {}, false);
      if (leavingForCollection || root.classList.contains("is-diving") || currentRoomUrl() !== focusUrl) {
        restoreFocusedRoom();
      }
    });
    armIdle();
  }

  /* ---------- KOLEKSIYON KARTI: renk noktasi tiklaninca gorsel + varyant degisir ---------- */
  function bindCardColorDots() {
    document.addEventListener("click", function (e) {
      var dot = e.target.closest && e.target.closest(".rl-card__dot");
      if (!dot) return;
      e.preventDefault();
      e.stopPropagation();
      var card = dot.closest(".rl-card");
      if (!card) return;
      var image = dot.getAttribute("data-image");
      var image2x = dot.getAttribute("data-image-2x");
      var variantId = dot.getAttribute("data-variant-id");
      if (image) {
        var img = card.querySelector(".rl-card__media img");
        if (img) {
          img.src = image;
          if (image2x) img.srcset = image + " 700w, " + image2x + " 1400w";
          else img.removeAttribute("srcset");
        }
      }
      Array.prototype.slice.call(card.querySelectorAll(".rl-card__dot")).forEach(function (d) { d.classList.remove("is-active"); });
      dot.classList.add("is-active");
      if (variantId) {
        // CTA da dahil ("Secenekleri Gor" / "Tasarla") — Sepete Ekle button oldugu icin a[href] filtresi sart.
        Array.prototype.slice.call(card.querySelectorAll(".rl-card__media, .rl-card__title, a.rl-card__add[href]")).forEach(function (link) {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set("variant", variantId);
          link.href = url.pathname + url.search;
        });
      }
    });
  }

  /* ---------- LAB ICINDE KOLEKSIYON + URUN DEVAMLILIGI ---------- */
  function sceneTransitionState() {
    try {
      var raw = window.sessionStorage.getItem("rlSceneTransition");
      if (!raw) return null;
      window.sessionStorage.removeItem("rlSceneTransition");
      var state = JSON.parse(raw);
      return state && Date.now() - Number(state.at || 0) < 6000 ? state : null;
    } catch (ignore) { return null; }
  }

  function initLabScene(root) {
    if (!root || root.getAttribute("data-scene-ready") === "1") return;
    root.setAttribute("data-scene-ready", "1");
    // Varis animasyonu KALDIRILDI (Doruk: studio dalisi + varis = cift animasyon, buglu his). State yine tuketilir.
    sceneTransitionState();

    if (!root.matches("[data-ruglab-collection]")) return;
    var key = root.getAttribute("data-lab-key") || "";
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-spatial-card]"));
    if (!cards.length || reducedMotion()) return;
    var ticking = false;
    function updateDepth() {
      ticking = false;
      var vh = Math.max(1, window.innerHeight);
      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var distance = Math.abs(center - vh * .5) / (vh * .72);
        card.style.setProperty("--spatial", clamp(1 - distance, .18, 1).toFixed(3));
      });
      var progress = clamp(window.scrollY / Math.max(vh * 2.4, 1), 0, 1);
      root.style.setProperty("--scene-shift", (-progress * 2.2).toFixed(2) + "vh");
      root.style.setProperty("--scene-scale", (1.035 + progress * .025).toFixed(3));
    }
    function requestDepth() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateDepth);
    }
    window.addEventListener("scroll", requestDepth, { passive: true });
    window.addEventListener("resize", requestDepth);
    updateDepth();

    cards.forEach(function (card) {
      Array.prototype.slice.call(card.querySelectorAll('a[href*="/products/"]')).forEach(function (link) {
        link.addEventListener("click", function (event) {
          if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          try { window.sessionStorage.setItem("rlSceneTransition", JSON.stringify({ key: key, at: Date.now(), from: "collection" })); } catch (ignore) {}
          card.classList.add("is-departing");
        });
      });
    });
  }

  /* ---------- PDP gorsel galerisi (Trendyol tarzi kaydirmali) ---------- */
  function initGallery(media) {
    if (!media || media.getAttribute("data-gal-ready") === "1") return;
    var imgs = Array.prototype.slice.call(media.querySelectorAll("img"));
    if (!imgs.length) return;
    media.setAttribute("data-gal-ready", "1");
    // Bilgilendirme/olcu-rehberi gibi UZUN gorseller (2:3+) cover'da kirpilir → contain'e gecir (is-tall).
    /* Cerceve orani secilen sekle gore degisir (2026-09-04).
       ONCE: cerceve hep dikeydi, yatay/kare mockup cover ile kirpiliyordu.
       SIMDI: dikey 3:2 dik, yatay 3:2 yatik, kare 1:1 -- mockup'lar cerceveyi
       birebir dolduruyor, kirpma yok. */
    /* 2026-09-07 (Doruk): galeri ARTIK FILTRELENMIYOR. Once secili sekle ait
       olmayan mockup'lar gizleniyordu; bu yuzden dikeydeyken yatay/kare
       mockup'lari gormek icin butona basmak gerekiyordu. Yanlisti -- galeriyi
       gezen kisi urunu tanimaya calisiyor, konfigure etmeye degil.
       SIMDI: hepsi tek serit halinde kaydirilir, CERCEVE o an gorunen gorselin
       oranini alir. Sekil butonu filtre degil, "beni o mockup'a goturur". */
    var aktifOran = 1.25;
    var ORAN_ALT = 0.6, ORAN_UST = 1.55;   /* uc noktalarda cerceve bozulmasin */
    var aktifYon = "dikey";

    /* Gorsel orani cerceveden belirgin farkliysa KIRPMA, sigdir. Boylece
       rehber gorselleri (1080x1350) ve artwork master (1:1) her yonde tam
       gorunur. Esik %18: kucuk farkta cover daha iyi durur (bant olusmaz). */
    function oturt(im) {
      if (!im.naturalWidth || !im.naturalHeight) return;
      var gOran = im.naturalHeight / im.naturalWidth;
      var cOran = aktifOran;
      var sigdir = Math.abs(gOran - cOran) / cOran > 0.18;
      im.classList.toggle("is-tall", sigdir);
      /* 2026-09-11 (Doruk: "bosluk bedelini istemiyorum"): sigdirilan gorselde bos kalan
         alan duz koyu renk yerine AYNI gorselin 24px'lik kopyasiyla dolar. Tarayici onu
         buyuturken yumusattigi icin bulanik bir fon olur: kirpma yok, bant hissi yok,
         cerceve sabit kaldigi icin kaydirma bozulmaz. */
      if (sigdir) {
        var k = im.currentSrc || im.src;
        try { var u = new URL(k, location.href); u.searchParams.set("width", "24"); k = u.toString(); } catch (e) {}
        im.style.backgroundImage = 'linear-gradient(rgba(12,12,12,.38), rgba(12,12,12,.38)), url("' + k + '")';
        im.style.backgroundSize = "cover";
        im.style.backgroundPosition = "center";
      } else {
        im.style.backgroundImage = "";
      }
    }
    function hepsiniOturt() { imgs.forEach(oturt); }
    imgs.forEach(function (im) {
      if (im.complete) oturt(im);
      else im.addEventListener("load", function () { oturt(im); });
    });
    var wrap = media.closest(".rl-gal");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "rl-gal";
      media.parentNode.insertBefore(wrap, media);
      wrap.appendChild(media);
    }
    media.classList.add("rl-gal__track");

    var dots = wrap.querySelector("[data-gal-dots]") || wrap.querySelector(".rl-gal__dots");
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "rl-gal__dots";
      wrap.appendChild(dots);
    } else {
      dots.hidden = false;
      dots.removeAttribute("hidden");
    }

    /* 2026-09-03: kucuk onizleme seridi. Gerekce: galeri cercevesine ust sinir
       koyunca (letterbox duzeltmesi) sag kutu daha uzun kaldiginda altta ciplak
       arkaplan bosluğu aciliyordu. Serit hem o bosluğu isle dolduruyor hem de
       musteri oklara basmadan diger acilari goruyor.
       Mobilde de var (Doruk): orada tek satirda yatay kayar, noktalar gizlenir. */
    var thumbs = wrap.querySelector(".rl-gal__thumbs");
    if (!thumbs) {
      thumbs = document.createElement("div");
      thumbs.className = "rl-gal__thumbs";
      wrap.appendChild(thumbs);
    }

    function visible() { return imgs.filter(function (im) { return !im.hidden; }); }
    function scrollToIndex(i) { media.scrollTo({ left: i * media.clientWidth, behavior: "smooth" }); }

    /* Tam boy gorseli 72px kareye basmak israf; Shopify CDN width parametresini
       destekliyor. Cozulemezse orijinal src'ye duser. */
    function thumbSrc(u) {
      try { var url = new URL(u, location.href); url.searchParams.set("width", "180"); return url.toString(); }
      catch (e) { return u; }
    }

    function renderThumbs() {
      var vis = visible();
      thumbs.innerHTML = "";
      if (vis.length < 2) { thumbs.hidden = true; return; }
      thumbs.hidden = false;
      vis.forEach(function (img, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "rl-gal__thumb";
        b.setAttribute("aria-label", (i + 1) + ". gorsel");
        var t = document.createElement("img");
        t.src = thumbSrc(img.currentSrc || img.src);
        t.alt = "";
        t.loading = "lazy";
        b.appendChild(t);
        b.addEventListener("click", function () { scrollToIndex(i); });
        thumbs.appendChild(b);
      });
    }

    function renderDots() {
      var vis = visible();
      dots.innerHTML = "";
      if (vis.length < 2) { dots.style.display = "none"; return; }
      dots.style.display = "";
      vis.forEach(function (img, i) {
        var d = document.createElement("button");
        d.type = "button"; d.className = "rl-gal__dot"; d.setAttribute("aria-label", (i + 1) + ". görsel");
        d.addEventListener("click", function () { scrollToIndex(i); });
        dots.appendChild(d);
      });
    }

    function arrow(dir, label, glyph) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "rl-gal__arw rl-gal__arw--" + (dir < 0 ? "prev" : "next");
      b.setAttribute("aria-label", label); b.textContent = glyph;
      b.addEventListener("click", function () {
        var vis = visible(); if (vis.length < 2) return;
        var idx = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
        var t = idx + dir;
        if (t < 0) t = vis.length - 1;           // baştayken geri → sona (loop)
        else if (t >= vis.length) t = 0;         // sondayken ileri → başa (loop)
        scrollToIndex(t);
      });
      wrap.appendChild(b);
      return b;
    }
    var prevArw = wrap.querySelector(".rl-gal__arw--prev");
    var nextArw = wrap.querySelector(".rl-gal__arw--next");
    if (!prevArw) prevArw = arrow(-1, "Önceki görsel", "‹");
    if (!nextArw) nextArw = arrow(1, "Sonraki görsel", "›");

    /* Serit kaydikca cerceve o an ortadaki gorselin oranina gecer. */
    function cerceveyiGuncelle() {
      /* 2026-09-11 (3. tur): MOBILDE cerceve orani SABIT (4:5). Kaydirma bittikten sonra
         bile cerceveyi .28s boyutlandirmak, bir sonraki kaydirmaya denk geldiginde snap'i
         bozuyordu (Doruk: 'hala saclamaliyor'). Farkli oranli gorseller is-tall (contain)
         ile kirpilmadan sigar. Masaustu davranisi degismedi. */
      if (!window.matchMedia("(min-width: 600px)").matches) return;
      var vis = visible();
      if (!vis.length) return;
      var idx = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
      var im = vis[Math.max(0, Math.min(idx, vis.length - 1))];
      if (!im || !im.naturalWidth || !im.naturalHeight) return;
      var oran = im.naturalHeight / im.naturalWidth;
      oran = Math.max(ORAN_ALT, Math.min(ORAN_UST, oran));
      if (Math.abs(oran - aktifOran) < 0.02) return;   /* gereksiz yeniden cizim yok */
      aktifOran = oran;
      hepsiniOturt();
      if (media.rlLockDesktopFrame) media.rlLockDesktopFrame();
    }

    /* 2026-09-11 (Doruk: "gorselleri kaydirirken mobilde sacmaliyor", 2. sikayet).
       KOK SEBEP: kaydirma sirasinda HER karede cerceveyiGuncelle() calisiyordu; parmak
       iki gorselin ortasini gecince cerceve yeni gorselin oranina gore BOYUNU
       degistiriyordu (CSS'te .28s aspect-ratio/height gecisi). Snap noktalari hareket
       surerken yer degistirdigi icin kaydirma iki gorselin arasinda kaliyor/sekiyordu.
       COZUM: kaydirma sirasinda yalniz nokta/kucuk resim isaretleri guncellenir;
       cerceve orani kaydirma OTURDUKTAN sonra (scrollend ya da 160 ms sessizlik) degisir.
       (=== true: olay nesnesi/rAF zaman damgasi gibi arguman gelirse cerceve yine guncellenir.) */
    function update(kaydirmaSirasinda) {
      if (kaydirmaSirasinda !== true) cerceveyiGuncelle();
      var vis = visible();
      var solo = vis.length < 2;
      prevArw.style.display = solo ? "none" : "";
      nextArw.style.display = solo ? "none" : "";
      var idx = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
      var dotEls = dots.children;
      for (var i = 0; i < dotEls.length; i++) dotEls[i].classList.toggle("is-active", i === idx);
      var thEls = thumbs.children;
      for (var j = 0; j < thEls.length; j++) thEls[j].classList.toggle("is-active", j === idx);
      /* Mobilde serit tek satirda yatay kayiyor: aktif kare gorus disinda kalmasin. */
      var act = thEls[idx];
      /* Kucuk resim seridini kaydirma SURERKEN oynatma; yalniz oturunca (update()). */
      if (kaydirmaSirasinda !== true && act && thumbs.scrollWidth > thumbs.clientWidth + 4) {
        var al = act.offsetLeft, ar = al + act.offsetWidth;
        if (al < thumbs.scrollLeft || ar > thumbs.scrollLeft + thumbs.clientWidth) {
          thumbs.scrollTo({ left: Math.max(0, al - 16), behavior: "smooth" });
        }
      }
    }
    var raf, oturT;
    media.addEventListener("scroll", function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () { update(true); });
      window.clearTimeout(oturT);
      oturT = window.setTimeout(update, 160);   /* scrollend yoksa (eski Safari) yedek */
    }, { passive: true });
    media.addEventListener("scrollend", function () { window.clearTimeout(oturT); update(); });

    /* 2026-09-11 (Doruk, 4. sikayet): "yarim kaydirmada arada kaliyor; 0.2'de hissetse
       diger gorsele gecmeli". Dokunmatikte tarayicinin scroll-snap'ine GUVENILMIYOR (iOS'ta
       yarim kaydirmada oturmuyordu). Yatay hareketi JS yonetir: parmagi birebir takip eder;
       birakinca genisligin %20'sini asan ya da hizli bir fiske sonraki/onceki gorsele,
       aksi halde ayni gorsele doner -> arada kalmak imkansiz. Dikey sayfa kaydirma yerel
       kalir (CSS: touch-action: pan-y). Masaustu yerel snap ile devam eder. */
    if (window.matchMedia("(hover: none)").matches) {
      media.classList.add("rl-gal--js-kaydir");
      var bx = 0, by = 0, bs = 0, bt = 0, yon = 0, basIdx = 0;
      media.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) { yon = -1; return; }
        bx = e.touches[0].clientX; by = e.touches[0].clientY;
        bs = media.scrollLeft; bt = e.timeStamp; yon = 0;
        basIdx = Math.round(bs / Math.max(1, media.clientWidth));
      }, { passive: true });
      media.addEventListener("touchmove", function (e) {
        if (yon === -1 || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - bx, dy = e.touches[0].clientY - by;
        if (yon === 0) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          yon = Math.abs(dx) > Math.abs(dy) ? 1 : -1;   /* 1 = yatay (bizde), -1 = dikey (tarayicida) */
          if (yon === -1) return;
        }
        media.scrollLeft = bs - dx;
      }, { passive: true });
      media.addEventListener("touchend", function (e) {
        if (yon !== 1) { yon = 0; return; }
        yon = 0;
        var w = Math.max(1, media.clientWidth);
        var t = e.changedTouches && e.changedTouches[0];
        var dx = (t ? t.clientX : bx) - bx;
        var hiz = Math.abs(dx) / Math.max(1, e.timeStamp - bt);   /* px/ms: hizli fiske */
        var hedef = basIdx;
        if (Math.abs(dx) > w * 0.2 || (hiz > 0.35 && Math.abs(dx) > 24)) hedef = basIdx + (dx < 0 ? 1 : -1);
        hedef = Math.max(0, Math.min(visible().length - 1, hedef));
        scrollToIndex(hedef);
      }, { passive: true });
      media.addEventListener("touchcancel", function () {
        if (yon === 1) scrollToIndex(basIdx);
        yon = 0;
      }, { passive: true });
    }

    // Varyanta gore filtrele: ortak gorseller (varyantsiz) + secili varyantin gorseli goster; digerlerini gizle.
    // Boylece kilavuz gorselleri HER varyantin ardindan gelir, en sonda toplanmaz.
    media.rlFilterVariant = function (variantId) {
      variantId = String(variantId == null ? "" : variantId);
      var shown = 0;
      imgs.forEach(function (im) {
        var raw = im.getAttribute("data-variant-ids") || "";
        var ids = raw ? raw.split(",") : [];
        var show = ids.length === 0 || (variantId && ids.indexOf(variantId) !== -1);
        /* 2026-09-04: YON filtresi de BURADA uygulanmali. studio.js defer ile
           yukleniyor ve bolumun applyOrient("dikey") cagrisindan SONRA calisiyor;
           bu yuzden ilk acilista butun yonler birden goruluyordu, filtre ancak
           kullanici bir butona bastiktan sonra dogru calisiyordu. */
        im.hidden = !show;
        if (show) shown++;
      });
      if (shown === 0) imgs.forEach(function (im) { im.hidden = false; });
      media.scrollLeft = 0;
      renderDots();
      renderThumbs();
      update();
      if (media.rlLockDesktopFrame) media.rlLockDesktopFrame();
    };

    /* Yon butonu (dikey/yatay) bu kancayi CAGIRIYORDU ama tanimli degildi --
       yon degisince nokta sayisi eski kaliyordu. 2026-09-03'te baglandi. */
    /* Bolum kodu (applyOrient) buradan cerceveyi degistiriyor. */
    /* Bolum kodu buradan galeriyi bir sekle KAYDIRIR (gizlemez). */
    media.rlGoToOrient = function (yon) {
      aktifYon = yon;
      var vis = visible(), hedef = -1;
      for (var i = 0; i < vis.length; i++) {
        if (vis[i].getAttribute("data-orient") === yon) { hedef = i; break; }
      }
      if (hedef < 0) return false;
      scrollToIndex(hedef);
      /* Kullanici asagida kaldiysa galeriyi goruse getir -- yoksa sekli
         degistirip hicbir sey olmamis gibi hissediyor (Doruk). */
      var kap = media.closest(".rl-gal") || media;
      var r = kap.getBoundingClientRect();
      if (r.top < 8 || r.bottom > window.innerHeight) {
        kap.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return true;
    };

    media.rlSyncDots = function () {
      renderDots();
      renderThumbs();
      update();
      if (media.rlLockDesktopFrame) media.rlLockDesktopFrame();
    };

    media.rlLockDesktopFrame = lockDesktopFrame;

    renderDots();
    renderThumbs();
    update();

    function lockDesktopFrame() {
      /* 2026-09-07: oran MOBILDE de gecerli olmali. Onceden burada erken cikilip
         CSS'teki sabit "aspect-ratio: 4/5" (dikey) kaliyordu; yatay mockup o
         dikey cerceveye cover ile sigmadigi icin mobilde yine kirpiliyordu.
         (Doruk: "mobilde hala sigmiyor, mesela yatay".)
         CSS degiskeni olarak yaziyoruz -- aspect-ratio genislik/yukseklik ister,
         bizim oran yukseklik/genislik, o yuzden tersi alaniyor. */
      var _o = aktifOran;
      media.style.setProperty("--rl-gal-oran", String(Math.round((1 / _o) * 1000) / 1000));
      if (!window.matchMedia("(min-width: 600px)").matches) {
        media.style.height = "";
        media.style.maxHeight = "";
        imgs.forEach(function (im) {
          im.style.height = "";
          im.style.maxHeight = "";
        });
        return;
      }
      // DENGELI: galeri yuksekligi = sagdaki satin-alma kutusu (rl-pdp__info) ile ayni; ikisi alt alta ayni hizada bitsin.
      var info = document.querySelector(".rl-pdp__info");
      var targetH = info ? Math.round(info.getBoundingClientRect().height) : media.clientWidth;
      /* 2026-09-03: cerceveye UST SINIR. Onceden galeri, sag kutu ne kadar uzarsa
         o kadar uzuyordu; yatay cip satiri eklenince ve ozel olcu paneli acilinca
         gorsel letterbox olup bozuluyordu (Doruk). Hizalama korunur, tasma kesilir. */
      /* Cerceve yuksekligi ARTIK secilen seklin orani. Sag kutu bundan uzunsa
         fark thumbnail seridi + sticky ile karsilaniyor. */
      var istenen = Math.round(media.clientWidth * aktifOran);
      var capH = Math.min(istenen, Math.round(window.innerHeight * 0.9));
      if (capH > 0) targetH = capH;
      media.style.height = targetH + "px";
      media.style.maxHeight = targetH + "px";
      media.style.overflowY = "hidden";
      imgs.forEach(function (im) {
        if (im.hidden) return;
        im.style.height = targetH + "px";
        im.style.maxHeight = targetH + "px";
        im.style.width = "100%";
        im.style.flex = "0 0 100%";
      });
    }
    lockDesktopFrame();
    window.addEventListener("resize", lockDesktopFrame);
    /* Sag kutu buyuyup kuculdukce (ozel olcu paneli acilir/kapanir) cerceve
       yeniden hizalansin. rAF: gozlemci dongusune girmesin diye tek kare bekler. */
    if (window.ResizeObserver) {
      var infoEl = document.querySelector(".rl-pdp__info");
      if (infoEl) {
        var pending = false;
        new ResizeObserver(function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () { pending = false; lockDesktopFrame(); });
        }).observe(infoEl);
      }
    }

    var initVar = media.getAttribute("data-init-variant");
    if (initVar) media.rlFilterVariant(initVar);
  }
  function initGalleries() {
    Array.prototype.slice.call(document.querySelectorAll(".rl-pdp__media")).forEach(initGallery);
  }

  function boot() {
    bindGlobal();
    bindCardColorDots();
    fixPillowPageText();
    initGalleries();
    Array.prototype.slice.call(document.querySelectorAll("[data-ruglab-studio]")).forEach(initStudio);
    Array.prototype.slice.call(document.querySelectorAll("[data-lab-scene]")).forEach(initLabScene);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
